import { Container, Texture } from '../../../odie';
import { SkullBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { ExtendedMovieClip } from 'src/game/animation/ExtendedMovieClip';

/*
    skull block view
*/
export class SkullBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _animation!: ExtendedMovieClip;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    const newCount = Math.min(value, 1);
    if (this._count === newCount) {
      return;
    }
    this._count = newCount;
    const animValue = 2 - newCount;
    this._animation.reverse = animValue === 1;
    this._animation.playAsync(`mole_transition`).then(() => {
      this._animation.reverse = false;
      this._animation.loop(`mole_state0${animValue}`);
    });
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: SkullBlockProps) {
    // create base view
    super();

    this._animation = new ExtendedMovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/skull'),
      defaultAnimation: 'mole_state01',
    });
    this._animation.updateOpts({ scale: 0.95 });
    this._count = 1;

    blockPositionView(this, props);
    this.y = 40;
  }

  public static assets() {
    return [
      {
        url: getMatch2AssetPath('blocks/skull'),
        loadMethod: ExtendedMovieClip.animationLoader,
      },
    ];
  }
}
